import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoRedLarge = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 150,
	height: 50,
	viewBox: "0 0 150 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "logo",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Vector",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M21.0539 25.5106L50.4125 25.2516C50.4134 25.1683 50.4143 25.0846 50.4143 25.0012C50.4143 24.2907 50.3843 23.5885 50.326 22.8936L22.1196 22.5989C21.9853 22.5989 21.8783 22.4916 21.8783 22.3596C21.8783 22.2277 21.9853 22.1203 22.1196 22.1203L50.2168 21.8617C50.1163 21.0616 49.9767 20.2739 49.8009 19.4984L23.1728 19.2087C23.0394 19.2087 22.9315 19.1017 22.9315 18.9694C22.9315 18.8374 23.0394 18.7304 23.1728 18.7304L49.5466 18.4757C49.3282 17.6692 49.0693 16.8805 48.7728 16.1094L24.2372 15.8175C24.1042 15.8175 23.9959 15.7114 23.9959 15.5794C23.9959 15.4475 24.1042 15.3401 24.2372 15.3401L48.3528 15.0845C44.4826 6.21024 35.5763 0 25.2073 0C12.865 0 2.59464 8.79831 0.423032 20.4151L36.596 19.9171L36.1147 21.4523L0.338984 20.8912C0.179882 21.841 0.076915 22.8081 0.0300837 23.7909L35.5344 23.2895L35.0543 24.825L0.0111651 24.2639C0.00496225 24.5094 0 24.7539 0 25.0012C0 25.7281 0.0310141 26.4487 0.092422 27.159L34.474 26.6631L33.9939 28.1983L0.139253 27.6447C0.243151 28.6222 0.403493 29.5822 0.617491 30.5225L33.4251 30.0359L32.945 31.571L0.739066 31.0318C0.983457 32.0124 1.28802 32.9703 1.64561 33.901L32.3607 33.4095L31.8803 34.9447L1.84627 34.4055C2.25162 35.3975 2.72149 36.3584 3.24749 37.2821L31.3118 36.7822L30.8314 38.3174L3.53871 37.7779C4.14689 38.7905 4.82579 39.7563 5.56796 40.6699L30.0976 40.1556L29.616 41.6911L5.96401 41.1454C10.5873 46.5614 17.4913 50 25.2073 50C36.2853 50 45.6937 42.9137 49.0745 33.061L18.9239 32.7691C18.7908 32.7691 18.6826 32.6618 18.6826 32.5298C18.6826 32.3982 18.7908 32.2908 18.9239 32.2908L49.403 32.034C49.6306 31.2607 49.822 30.472 49.9746 29.6689L19.9883 29.3789C19.8552 29.3789 19.7473 29.2718 19.7473 29.1399C19.7473 29.0079 19.8552 28.9006 19.9883 28.9006L50.1492 28.6345C50.2627 27.8624 50.3418 27.0778 50.3812 26.2839L21.0539 25.9889C20.9209 25.9889 20.8129 25.8816 20.8129 25.7496C20.8129 25.6179 20.9209 25.5106 21.0539 25.5106Z",
					fill: "#F63333"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M107.795 15.6914H100.302L89.9566 32.934H97.0023L98.6081 29.8248H102.98L103.16 32.934H109.233L107.795 15.6914ZM100.4 25.7835L102.723 20.8952L102.83 25.7835H100.4Z",
					fill: "#F63333"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M89.0277 21.3677C88.7742 22.1807 88.251 22.3639 87.1499 22.3773H85.6824L86.3794 20.136H87.7481C88.6943 20.136 89.2554 20.6393 89.0277 21.3677ZM94.8653 20.7636C95.2676 18.9678 94.5311 15.6914 88.6171 15.6914H81.1892L75.6796 32.934H82.3034L84.4726 25.9877L86.6779 32.934H93.4358L90.2016 25.8205C93.2573 24.8833 94.2978 23.3094 94.8653 20.7636Z",
					fill: "#F63333"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M80.6752 15.6914H64.5229L62.8264 20.9879H67.9684L64.1352 32.934H70.7395L74.573 20.9879H78.9775L80.6752 15.6914Z",
					fill: "#F63333"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M143.319 20.628L144.931 15.6914H132.023L126.369 32.934H139.296L140.832 28.2582H134.409L134.958 26.5821H141.358L142.791 22.2071H136.393L136.91 20.628H143.319Z",
					fill: "#F63333"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M118.81 32.934H125.081L130.653 15.6914H124.005L121.677 23.3287L119.71 15.6914H113.38L107.807 32.934H114.455L116.814 25.1858L118.81 32.934Z",
					fill: "#F63333"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M147.819 16.8394V16.1977H148.244C148.461 16.1977 148.691 16.2455 148.691 16.5021C148.691 16.8204 148.455 16.8394 148.192 16.8394H147.819ZM147.819 17.1054H148.177L148.72 18.0027H149.07L148.484 17.0906C148.786 17.0526 149.018 16.8912 149.018 16.5211C149.018 16.113 148.777 15.9326 148.291 15.9326H147.507V18.0027H147.819V17.1054ZM148.196 18.762C149.169 18.762 150 18.0027 150 16.9624C150 15.9326 149.169 15.172 148.196 15.172C147.214 15.172 146.384 15.9326 146.384 16.9624C146.384 18.0027 147.214 18.762 148.196 18.762ZM146.742 16.9624C146.742 16.113 147.379 15.4713 148.196 15.4713C149.004 15.4713 149.641 16.113 149.641 16.9624C149.641 17.8268 149.004 18.463 148.196 18.463C147.379 18.463 146.742 17.8268 146.742 16.9624Z",
					fill: "#F63333"
				})
			]
		})
	})
});
export default SvgLogoRedLarge;
